import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import { ReportStatuses, StatusTypes } from '@dashboard-experience/utils';
import { i18n as mastodonI18n } from '@international/mastodon-i18n';
import styled from 'styled-components';
import StatusBadgeAssessComplete from './StatusBadgeAssessComplete';

// TODO: remove once mastodon is updated and assess badges are rendering properly
export const StyledAssessStatusBadge = styled.div`
  /* overall icon sizing and positioning */
  .mastodon-status-icon .mastodon-icon {
    width: 16px !important;
    height: 16px !important;
    vertical-align: initial !important;
    flex-wrap: nowrap !important;
  }

  /* positioning the icon background div */
  .mastodon-status-icon {
    position: absolute !important;
    left: 2px !important;
    top: 2px !important;
  }

  /* positioning the icon foreground svg */
  .mastodon-icon {
    white-space: nowrap !important;
    position: absolute !important;
    left: 0 !important;
  }

  /* gray status badge background */
  .mastodon-status-badge.text-capitalize.assess.suspended,
  .mastodon-status-badge.text-capitalize.assess.canceled,
  .mastodon-status-badge.text-capitalize.assess.pending,
  .mastodon-status-badge.text-capitalize.assess.dispute {
    background-color: #f2f5f7 !important;
  }
`;

interface StatusBadgeProps {
  status: string;
  statusType: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, statusType }) => {
  const badgeProps = {
    'data-testid': 'status-badge',
    className: 'text-capitalize',
    statusType,
    label: mastodonI18n.getStr(`badges.${status}`),
    status: status === 'submitted' ? ReportStatuses.COMPLETE : status,
  };

  // TODO: remove once mastodon is updated and assess badges are rendering properly
  const badgeStyle = {
    padding: '2px 8px 2px 22px',
    borderRadius: '.625rem',
    fontSize: '12px',
    height: '1.25rem',
    lineHeight: 'calc(1.25rem - 4px)',
    color: '#1a2026',
    border: '0',
    display: 'inline-block',
    fontWeight: 500,
  };

  if (statusType === StatusTypes.Assess) {
    // TODO: this entire 'if' block can be removed once mastodon is updated
    // and assess badges are rendering properly
    return (
      <StyledAssessStatusBadge data-testid='styled-assess-status-badge'>
        {badgeProps.status === ReportStatuses.COMPLETE ? (
          <StatusBadgeAssessComplete {...badgeProps} badgeStyle={badgeStyle} />
        ) : (
          <M.StatusBadge {...badgeProps} style={badgeStyle} />
        )}
      </StyledAssessStatusBadge>
    );
  }

  return <M.StatusBadge {...badgeProps} />;
};

export default StatusBadge;
